/**************************************************
 * Nombre:       ExportadorDatos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import Formulario_Fechas from "../Formularios/Formulario_Fechas";
import {CloudDownload} from '@mui/icons-material'
import {LoadingButton} from "@mui/lab";
import {useState} from "react";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";
import {and, collection, or, query, where} from "firebase/firestore";
import {ESTADOSRESERVAS} from "../../Modulo_Motor_Reservas/Constantes";
import * as XLSX from 'xlsx';
import {saveAs} from 'file-saver';
import {adaptador_reservas_exportacion} from "../Adaptadores/adaptador_reservas_exportacion";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import {adaptador_reservas_acompanantes_exportacion} from "../Adaptadores/adaptador_reservas_acompanantes_exportacion";
import {adaptador_reservas_exportacion_todo} from "../Adaptadores/adaptador_reservas_exportacion_todo";
import {fire} from "../../fire";
import {obtenerColeccionQuery} from "../../Servicios/BD/obtenerColeccionQuery";

const ExportadorDatos = () => {
    const {sCell} = useResponsive()
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: {}})
    const [cargando, setCargando] = useState(false)

    const exportarDatos = async () => {

        let entidad = await obtenerEntidad()
        let fechaIni = new Date(entidad.fechaInicio).setHours(0, 0, 0, 0)
        let fechaFin = new Date(entidad.fechaFinal).setHours(23, 59, 59, 0)

        let inicioTime = new Date(fechaIni).getTime()
        let finTime = new Date(fechaFin).getTime()

        let w = [where('fechaCheckOut', '>=', inicioTime), where('fechaCheckOut', '<=', finTime), where('estado', '==', ESTADOSRESERVAS[4])]
        setCargando(true)
        let dox = await obtenerColWheres({col: 'reservas', wheres: w})

        if (dox.res) {
            let arr = adaptador_reservas_exportacion(dox.data)
            let arrAcompanantes = adaptador_reservas_acompanantes_exportacion(dox.data)
            const libroHuspes = XLSX.utils.json_to_sheet(arr)
            const libroAcompas = XLSX.utils.json_to_sheet(arrAcompanantes)
            const workbook = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(workbook, libroHuspes, "HUESPED1")
            XLSX.utils.book_append_sheet(workbook, libroAcompas, "HUESPED2")

            // Buffer to store the generated Excel file
            const excelBuffer = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});
            const blob = new Blob([excelBuffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'});

            saveAs(blob, "Reservas.xlsx");

        }
        setCargando(false)

    }

    const exportarDatosTodos = async () => {

        let entidad = await obtenerEntidad()
        let fechaIni = new Date(entidad.fechaInicio).setHours(0, 0, 0, 0)
        let fechaFin = new Date(entidad.fechaFinal).setHours(23, 59, 59, 0)

        let inicioTime = new Date(fechaIni).getTime()
        let finTime = new Date(fechaFin).getTime()

       // let w = [where('fechaCheckIn', '>=', inicioTime), where('fechaCheckIn', '<=', finTime),]

        let ref = collection(fire, 'reservas')
        let q = query(ref, or(
            and(where('fechaCheckIn', '>=', inicioTime), where('fechaCheckIn', '<=', finTime)),
            and(where('fechaCheckOut', '>=', inicioTime), where('fechaCheckOut', '<=', finTime)),
            where('estado', '==', ESTADOSRESERVAS[1])
        ))

        setCargando(true)
        let dox = await obtenerColeccionQuery(q)

        if (dox.res) {
            let arr = adaptador_reservas_exportacion_todo(dox.data)
            const libroHuspes = XLSX.utils.json_to_sheet(arr)
            const workbook = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(workbook, libroHuspes, "OCUPACION")

            // Buffer to store the generated Excel file
            const excelBuffer = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});
            const blob = new Blob([excelBuffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'});

            saveAs(blob, "Reservas Todo.xlsx");

        }
        setCargando(false)

    }


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={2}
            sx={{pl: 2}}

        >

            <Grid container size={{xs: 12, sm: 12, md: 8}}>
                <Formulario_Fechas props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 2}} justifyContent={sCell ? 'center' : 'flex-start'}>
                <LoadingButton
                    fullWidth
                    onClick={() => exportarDatos()}
                    loading={cargando} variant={'outlined'}
                    startIcon={<CloudDownload/>}>TRA</LoadingButton>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 2}} justifyContent={sCell ? 'center' : 'flex-start'}>
                <LoadingButton
                    fullWidth
                    onClick={() => exportarDatosTodos()}
                    loading={cargando} variant={'outlined'}
                    startIcon={<CloudDownload/>}>Todo</LoadingButton>
            </Grid>


        </Grid>
    )

}
export default ExportadorDatos